import styled from 'styled-components';

export const StyledElement = styled.span`
  cursor: pointer;

  &:hover {
    p {
      text-decoration: underline;
    }
  }
`;
